import { createSlice, Slice } from '@reduxjs/toolkit';

import { DiscountState, FetchStatus } from '../root-types';
import { startProvAuth } from '../actions/auth-actions';
import { logout } from '../actions/auth-thunks';
import { getDiscountStatus } from '../actions/discount-thunks';
import { selectCustomerLocation } from 'app/store/actions/user-context-actions';

const initialState: DiscountState = {
  fetchStatus: FetchStatus.NOT_STARTED,
};

const discountSlice: Slice<DiscountState> = createSlice({
  name: 'discount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(selectCustomerLocation, () => initialState);
    builder.addCase(logout.fulfilled, () => initialState);
    builder.addCase(startProvAuth, () => initialState);

    builder.addCase(getDiscountStatus.fulfilled, (state, action) => {
      state.discountStatus = action.payload;
      state.fetchStatus = FetchStatus.FULFILLED;
    });
    builder.addCase(getDiscountStatus.pending, (state) => {
      state.fetchStatus = FetchStatus.PENDING;
    });
    builder.addCase(getDiscountStatus.rejected, (state) => {
      state.fetchStatus = FetchStatus.REJECTED;
    });
  },
});

const { reducer } = discountSlice;

export { reducer };
